export default "__VITE_ASSET__o4YZr$nA__"